/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInvoiceFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type Invoice, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Invoice/{id}
 */
export interface InvoiceItemRequestBuilder extends BaseRequestBuilder<InvoiceItemRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Invoice>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Invoice | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InvoiceItemRequestBuilderUriTemplate = "{+baseurl}/Invoice/{id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const InvoiceItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: InvoiceItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
